export default class FormSubmitDisable {
  constructor() {
    const forms = document.querySelectorAll('form');
    forms.forEach((form) => {
      form.addEventListener('submit', () => {
        const submits = form.querySelectorAll('[type="submit"]');
        submits.forEach((btn) => {
          btn.disabled = true;
          btn.innerHTML = `<div class="loader__graphic">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            </div>`;
        });
      });
    });
  }
}
